
export const FETCH_WORKFLOWLIST='CORPORATE_QUOTE_WORKLFOW_SETUP/FETCH_LIST';

export type Action=
    {type:FETCH_WORKFLOWLIST,data:Object}


// WEBPACK FOOTER //
// ./src/features/corporate-quote-workflow-setup/action-types.js